import { render, staticRenderFns } from "./OddEvenCart.vue?vue&type=template&id=37959c5d&scoped=true"
import script from "./OddEvenCart.vue?vue&type=script&lang=js"
export * from "./OddEvenCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37959c5d",
  null
  
)

export default component.exports